import { useRef } from 'react';

export const useDebouncedFunction = () => {
  const timeoutId = useRef<NodeJS.Timeout | null>(null);

  const debouncedFunction = (func: (...args: unknown[]) => unknown) => {
    if (timeoutId?.current) {
      clearTimeout(timeoutId.current);
    }

    timeoutId.current = setTimeout(() => {
      func();
    }, 700);
  };

  return { debouncedFunction };
};
